<template>
  <div class="intro">
    <div class="intro--container container">
      <div class="intro--copy">
        <Heading
          type="h1"
          shuffle
          glow
          loop
          accent
          :shuffleDuration="1000"
          text="Front-End Developer"
          className="intro--title"
          :viewable="true"
        />
        <div class="intro--body-copy">
          <Heading
            type="h3"
            text="LUCAS MCCALLUM"
            className="h6"
            :viewable="true"
          />
          <p class="lead">
            I am a front-end and creative developer based in Toronto, Canada. I
            blend the gap between design and development by creating scalable,
            interactive, and versatile web experiences for both the client and
            the user. I've worked on projects for big brands and small brands
            ranging from various budgets.
          </p>
          <div class="intro-button-group">
            <Button :callback="menuToggle" href="/projects"
              >View Projects</Button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Heading from "@/components/Heading";

export default {
  name: "Home",
  components: {
    Button,
    Heading,
  },

  metaInfo: {
    title: "Home",
    meta: [
      {
        name: "description",
        content: `Lucas McCallum is a front-end & creative developer based in Toronto, Canada. He blends the gap between design and development by creating unique, interactive, and efficient web experiences.`,
      },
    ],
  },
  methods: {
    menuToggle: function () {
      this.$emit("open-menu");
    },
  },
  mounted() {
    const homeTl = this.gsap.timeline();
    homeTl
      .fromTo(
        ".intro--title",
        {
          y: 20,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1.25,
        },
      )
      .fromTo(
        ".intro--body-copy",
        {
          y: 20,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1.5,
        },
        "-=1",
      );
  },
};
</script>
